module.exports = __webpack_public_path__ + "wafuss3.672b3f664a8d41a0b3dec92ebcc6c0a0.jpg";